import cn from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var CustomButton = function CustomButton(_ref) {
  var disabled = _ref.disabled,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    onClick: onClick,
    className: cn(
    // Dimensions
    'tw-w-full tw-py-0.8 tw-rounded-1',
    // Background
    'tw-transition-colors', disabled ? 'tw-bg-neutral-light-400' : 'tw-bg-primary-light-500 hover:tw-bg-primary-light-400 dark:tw-bg-primary-dark-600 dark:hover:tw-bg-primary-dark-500',
    // Text
    'tw-text-center tw-font-link2', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-100',
    // Others
    'tw-rounded-1', disabled && 'tw-btn-disabled'),
    disabled: disabled,
    children: children
  });
};
export default CustomButton;